import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import AsideTitle from '../../../../components/asideTitle';
import { rel } from '../../../../../../utils/rel';

class GoodbookList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        if (content.length === 0) return <div />;

        return (
            <div className={styles.box}>
                <AsideTitle title="好书精选" />
                <ul>
                    {content.map((item, index) => (
                        <li key={index} className="clearfix">
                            <a href={item.url} target="_blank" rel={rel} title={item.title}>
                                {item.img && item.img !== '' ? <img src={item.img} alt={item.title} /> : ''}
                                <p>{item.title}</p>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(GoodbookList);
